import { autoinject, transient } from 'aurelia-dependency-injection';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { Dashboard } from '../../../../models/dashboard/dashboard.models';
import { DashboardView } from '../dashboard';
import { ValidationsClientService } from '../../../../services/validations/validations-client.service';

@transient()
@autoinject()
export class EditDashboardsMetadataDialog {
    public dashboards: Dashboard[];
    private deletedDashboards: Dashboard[] = [];
    public dashboardRoleLinks: { [dashboardId: number]: boolean }
    private dashboardViewModel: DashboardView;

    constructor(private dialogClient: DialogClientService,
        private dashboardClientService: DashboardClientService,
        private validationsClientService: ValidationsClientService) {
        this.dashboardClientService.getDashboardsForUser()
            .then(response => {
                this.dashboards = response.dashboards;
                this.dashboardRoleLinks = response.dashboardRoleLinks;
            })
    }

    remove(item: Dashboard) {
        this.dashboards.splice(this.dashboards.indexOf(item), 1);
        this.deletedDashboards.push(item);
    }

    saveDashboards() {
        return new Promise<void>((resolve, reject) => {
            this.dashboardClientService.persistDashboards(this.dashboards, this.dashboardRoleLinks)
                .then(resp => {
                    if (resp.validationResult && resp.validationResult.hasError) {
                        this.validationsClientService.showValidationErrors(resp.validationResult);
                        reject();
                    }
                    else {
                        this.dashboardViewModel.cleanTabsArray(this.deletedDashboards);
                        this.dashboardViewModel.loadUserDashboards();
                        this.dialogClient.hide();
                    }
                    resolve();
                })
                .catch(reject);
        })
    }

    cancel() {
        this.dialogClient.hide();
    }

    activate(viewModel: DashboardView) {
        this.dashboardViewModel = viewModel;
    }
}
